// Демо-данные живого макета «Входящие» для главной страницы Hub.
// Пока нет реального подключения WhatsApp/Telegram — показываем правдоподобную переписку.
// kind: in — сообщение клиента, out — ответ продавца, note — внутренняя заметка, system — системное событие.
import { t } from "@/lib/i18n";

export const inboxQuickReplies = [
  t("Здравствуйте! Отправляю прайс — посмотрите, пожалуйста."),
  t("Доставка по Москве — 1–2 дня, по России — 3–5 дней."),
  t("Счёт на юрлицо выставим в течение часа."),
  t("Могу закрепить этот диалог за вашим менеджером."),
];

export const inboxDialogs = [
  {
    id: "anna",
    name: t("Анна Смирнова"),
    company: t("Кафе «Пудра»"),
    channel: "whatsapp",
    phone: "+7 916 402-18-73",
    nick: "",
    owner: t("Дмитрий Орлов"),
    bot: false,
    unread: 2,
    time: "12:41",
    at: "2026-10-29T12:41:00+03:00",
    tags: [t("Новый заказ"), t("Опт")],
    messages: [
      { kind: "in", text: t("Здравствуйте! Нужен прайс на посуду для кафе — тарелки и стаканы."), time: "12:33" },
      { kind: "out", text: t("Добрый день! Отправляю прайс: 28 позиций, цены за комплект из 6 штук."), time: "12:37" },
      { kind: "in", text: t("Спасибо, посмотрю. А доставка в Казань до пятницы возможна?"), time: "12:40" },
      { kind: "in", text: t("И можно счёт на юрлицо?"), time: "12:41" },
    ],
  },
  {
    id: "igor",
    name: t("Игорь Лебедев"),
    company: t("ООО «Ромашка»"),
    channel: "telegram",
    phone: "+7 903 118-55-02",
    nick: "igor_lebedev",
    owner: t("Бот «Запись»"),
    bot: true,
    unread: 0,
    time: "11:14",
    at: "2026-10-29T11:14:00+03:00",
    tags: [t("Запись"), t("Бот")],
    messages: [
      { kind: "in", text: t("Здравствуйте, хочу записаться на консультацию."), time: "11:02" },
      { kind: "system", text: t("Диалог передан боту «Запись на консультацию»"), time: "11:02" },
      { kind: "out", text: t("Здравствуйте! Выберите удобный день: 28, 29 или 30 октября."), time: "11:03" },
      { kind: "in", text: t("29 октября"), time: "11:14" },
      { kind: "out", text: t("Отлично, 29 октября в 15:00. Подтвердите, пожалуйста, номер телефона."), time: "11:14" },
    ],
  },
  {
    id: "maria",
    name: t("Мария Ким"),
    company: t("Оптовая закупка"),
    channel: "whatsapp",
    phone: "+7 926 771-40-19",
    nick: "",
    owner: t("Алексей Ковалёв"),
    bot: false,
    unread: 0,
    time: "10:22",
    at: "2026-10-29T10:22:00+03:00",
    tags: [t("Доставка")],
    messages: [
      { kind: "in", text: t("Добрый день! Заказ №4812 уже отправлен?"), time: "10:18" },
      { kind: "out", text: t("Здравствуйте, Мария! Да, отправили вчера вечером, трек придёт на почту до 18:00."), time: "10:21" },
      { kind: "in", text: t("Спасибо!"), time: "10:22" },
      { kind: "out", text: t("Всегда рады помочь."), time: "10:22" },
    ],
  },
  {
    id: "sergey",
    name: t("Сергей Петров"),
    company: t("Договор №17"),
    channel: "telegram",
    phone: "+7 985 233-09-64",
    nick: "s_petrov17",
    owner: t("Дмитрий Орлов"),
    bot: false,
    unread: 1,
    time: "09:58",
    at: "2026-10-29T09:58:00+03:00",
    tags: [t("Счёт"), t("Срочно")],
    messages: [
      { kind: "in", text: t("Здравствуйте, нужен счёт на оплату по договору №17."), time: "09:47" },
      { kind: "note", text: t("Просит счёт на юрлицо, оплата должна пройти до пятницы."), time: "09:52" },
      { kind: "in", text: t("Когда сможете выставить?"), time: "09:58" },
    ],
  },
  {
    id: "elena",
    name: t("Елена Волкова"),
    company: t("Онлайн-школа"),
    channel: "whatsapp",
    phone: "+7 911 604-77-30",
    nick: "",
    owner: t("Бот «Заявки»"),
    bot: true,
    unread: 0,
    time: t("Вчера"),
    at: "2026-10-28T18:45:00+03:00",
    tags: [t("Заявка"), t("Бот")],
    messages: [
      { kind: "in", text: t("Хочу узнать про тариф для команды из 12 человек."), time: "18:41" },
      { kind: "system", text: t("Диалог передан боту «Сбор заявок»"), time: "18:41" },
      { kind: "out", text: t("Подскажите, пожалуйста, сферу деятельности и удобное время для звонка."), time: "18:42" },
      { kind: "in", text: t("Онлайн-школа, удобно завтра после 14:00."), time: "18:45" },
    ],
  },
  {
    id: "artem",
    name: t("Артём Кузнецов"),
    company: t("ИП Кузнецов"),
    channel: "telegram",
    phone: "+7 964 512-88-41",
    nick: "artem_kuz",
    owner: t("Ольга Смирнова"),
    bot: false,
    unread: 0,
    time: t("Вчера"),
    at: "2026-10-28T16:34:00+03:00",
    tags: [t("Возврат")],
    messages: [
      { kind: "in", text: t("Одна позиция пришла с трещиной, как оформить возврат?"), time: "16:12" },
      { kind: "out", text: t("Пришлите, пожалуйста, фото упаковки и самой позиции — оформим замену сегодня."), time: "16:20" },
      { kind: "in", text: t("Отправил фото."), time: "16:31" },
      { kind: "out", text: t("Принято, замена уедет завтра утром. Приносим извинения за доставленные неудобства."), time: "16:34" },
    ],
  },
  {
    id: "olga",
    name: t("Ольга Соколова"),
    company: t("Студия «Тон»"),
    channel: "whatsapp",
    phone: "+7 909 355-12-08",
    nick: "",
    owner: t("Дмитрий Орлов"),
    bot: false,
    unread: 1,
    time: t("Вчера"),
    at: "2026-10-28T15:12:00+03:00",
    tags: [t("Консультация")],
    messages: [
      { kind: "in", text: t("Здравствуйте! Можно ли подключить два номера WhatsApp на один аккаунт?"), time: "15:02" },
      { kind: "out", text: t("Да, в Hub можно добавить несколько номеров и раздать их продавцам по ролям."), time: "15:09" },
      { kind: "in", text: t("А аналитика по каждому номеру будет отдельная?"), time: "15:12" },
    ],
  },
  {
    id: "dmitry",
    name: t("Дмитрий Волков"),
    company: t("ООО «Сфера»"),
    channel: "telegram",
    phone: "+7 921 480-66-15",
    nick: "dmitry_volkov",
    owner: t("Алексей Ковалёв"),
    bot: false,
    unread: 0,
    time: t("Пн"),
    at: "2026-10-27T12:15:00+03:00",
    tags: ["API"],
    messages: [
      { kind: "in", text: t("Подскажите, есть ли API для выгрузки диалогов в нашу CRM?"), time: "12:04" },
      { kind: "out", text: t("Да, есть REST API и вебхуки на новые сообщения. Ключи выдаёт администратор аккаунта."), time: "12:11" },
      { kind: "in", text: t("Отлично, тогда берём."), time: "12:15" },
    ],
  },
];
